import React from 'react'
import { connect } from 'react-redux'

import {
  addBillingAddress,
  selectBillingAddress,
  deleteAddress,
  updateAddress
} from "./addressActionCreators"

import CheckoutAddressComponent from "./CheckoutAddressComponent"

const mapBillingAddressStateToProps = (state) => {
  const e = state.entities;
  const c = state.constants;
  const useShippingForBilling = state.ui.useShippingForBilling;
  return {
    addresses: e.BillingAddresses.map(
      id => e.Addresses.find((address) => address.Id === id)),
    selectedAddressId: e.SelectedBillingAddressId,
    addressType: c.BillingAddressType,
    addressActionCreators: {
      add: addBillingAddress,
      remove: deleteAddress,
      select: selectBillingAddress,
      update: updateAddress
    },
    selectAddressMessage: "Bill to this address",
    sectionLabel: "Billing Address",
    hidden: useShippingForBilling,
    editable: false
  }
};

const mapBillingAddressDispatchToProps = (dispatch) => ({
  onEndEdit: (Id) => dispatch(selectBillingAddress(Id))
})
const CheckoutBillingAddressContainer = connect(
  mapBillingAddressStateToProps,
  mapBillingAddressDispatchToProps
)(CheckoutAddressComponent)

export default CheckoutBillingAddressContainer;